import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import CreatableSelect from 'react-select/lib/Creatable';
import SelectService from '../../../services/SelectService';

import Alert from '../../../shared/components/Alert';

class AddTransactionModal extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      // locationID: PropTypes.string.isRequired,
      toggle: PropTypes.func.isRequired,
      handleChange: PropTypes.func.isRequired,
      postValue: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.shape({
         value: PropTypes.string,
         label: PropTypes.string,
         }),
      ]),
      handleSubmit: PropTypes.func,
      errorMsg: PropTypes.string,
   };

   static defaultProps = {
      modal: false,
      postValue: {},
      handleSubmit: (e) => {
         e.preventDefault();
         console.log('submitted');
      },
      errorMsg: '',
   };

   constructor() {
      super();
      this.state = {
         modal: false,
         transactionType: '2',
         deliverToVal: '',
      };

      this.isLoading = false;
      this.toggle = this.toggle.bind(this);
   }

   componentDidMount() {
      this.isLoading = true;
      this.getLocations('');
   }

   componentWillReceiveProps(nextProps) {
      const { postValue } = this.props;
      if (nextProps.postValue.transactionType !== postValue.transactionType) {
         this.setState({
            transactionType: nextProps.postValue.transactionType,
            deliverToVal: '',
         });
      }
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   getLocations = async (newValue) => {
      const { transactionType } = this.state;
      const locationID = 0;
      // const { locationID } = this.props;
      const formData = { searchFor: newValue, searchType: transactionType, locationid: locationID };
      const options = [];

      try {
         if (this.isLoading) {
         await SelectService.listLocationOptions(formData).then((response) => {
            if (response) {
               response.map(opt => (
               options.push({
                     value: opt.location_id,
                     label: opt.location_name,
               })
               ));
            }
         }).catch((error) => {
            console.log('Error: ', error.message);
         });
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }

      this.setState({ delivertoOptions: options });
   }

   handleSelectChange = (e) => {
      const t = e.target.value;
      const { handleChange } = this.props;
      this.setState({ transactionType: t });

      handleChange(false, 'deliver');
      handleChange(t, 'transaction');
      setTimeout(() => {
         this.getLocations('');
      }, 100);
   }

   handleInputChange = (e) => {
      const { delivertoOptions } = this.state;
      const testD = delivertoOptions.filter(item => item.label === e);
      if (testD.length <= 0) {
         this.setState({ deliverToVal: e });
      } else {
         this.setState({ deliverToVal: '' });
      }
   }

   toggle() {
      this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         modal, toggle, handleChange, handleSubmit, errorMsg, postValue,
      } = this.props;

      const {
         transactionType, delivertoOptions, deliverToVal,
      } = this.state;

      return (
         <div>
            <Modal
               isOpen={modal}
               className="modal-dialog--primary modal-dialog--header"
            >
               <div className="modal__header bg_blue">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text  modal__title">Return Stock</h4>
               </div>
               <form id="newTransaction_form" onSubmit={handleSubmit}>
                  <div className="modal__body">
                  { errorMsg && (
                     <div className="notif_msg">
                        <Alert color="danger" className="alert--colored m-b-10">
                        <p>{ errorMsg }</p>
                        </Alert>
                     </div>
                     )
                  }
                  <div className="form form--horizontal">
                     <div className="form__form-group">
                        <span className="form__form-group-label">Current Stock</span>
                        <div className="form__form-group-field">
                           <span className="text-danger bold fs-17">{postValue.currentStock ? `${postValue.currentStock} kgs.` : 0}</span>
                        </div>
                     </div>
                     <div className="form__form-group">
                        <span className="form__form-group-label">Quantity <i className="text-danger">(Kilos)</i><b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                           <input type="text" name="perKilo" value={postValue.perKilo ? postValue.perKilo : ''} placeholder="Quantity in kilos" onChange={e => handleChange(e, 'number')} />
                        </div>
                     </div>
                     <div className="form__form-group">
                        <span className="form__form-group-label">Return To:<b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                           <select onChange={this.handleSelectChange} value={transactionType}>
                              <option value="1">Warehouse</option>
                              <option value="2">Logistic</option>
                           </select>
                        </div>
                     </div>
                     <div className="form__form-group">
                        <span className="form__form-group-label">Location:<b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                           <CreatableSelect
                              name="deliverTo"
                              value={postValue.deliverTxt && postValue.deliverVal ? { label: postValue.deliverTxt ? postValue.deliverTxt : '', value: postValue.deliverVal ? postValue.deliverVal : '' } : ''}
                              options={delivertoOptions}
                              isClearable
                              onChange={e => handleChange(e, 'deliver')}
                              onInputChange={this.handleInputChange}
                              className="react-select"
                              classNamePrefix="react-select"
                              placeholder="Select delivery destination..."
                              isValidNewOption={transactionType === '4' && deliverToVal !== '' ? () => true : () => false}
                           />
                        </div>
                     </div>
                     <div className="form__form-group">
                        <span className="form__form-group-label">Reason <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                           <textarea name="reason" onChange={e => handleChange(e)} className="mh-150 no-resize" value={postValue.reason ? postValue.reason : ''} placeholder="Reason" />
                        </div>
                     </div>
                  </div>
                  </div>
                  <ButtonToolbar className="modal__footer">
                  <Button color="primary">Submit</Button>
                  <Button onClick={toggle}>Cancel</Button>
                  </ButtonToolbar>
               </form>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'vertical_form_layout', // a unique identifier for this form
})(withTranslation('common')(AddTransactionModal));
